import { BIM360Issue, BIM360IssueStatus } from '../BIM360Issue';
import { FrontendAPIHelper } from '../../FrontendAPIHelper';
import { PaginationRequest } from '../../util/PaginationParameters';
import _ from 'lodash';

const api = new FrontendAPIHelper();

class FrontendPatchProjectIssueResponse {

}

export class FrontendBIM360Issue extends BIM360Issue
{
    public clone!: any;

    public dueDateString = "";

    constructor() {
        super();
    }

    public async saveChanges()
    {
        const pagination = new PaginationRequest();
        let result = await api.callEndpoint(FrontendPatchProjectIssueResponse, 'PATCH', `issues/containers/${this.containerId}/quality-issues/${this.forgeId}`, pagination, {issue: this});
    }

    public saveChangesPromise() : Promise<any>
    {
        let issue = new FrontendBIM360Issue();
        issue.forgeId = this.forgeId;
        issue.status = this.status;
        return api.callEndpoint(FrontendPatchProjectIssueResponse, 'PATCH', `issues/containers/${this.containerId}/quality-issues/${this.forgeId}`, PaginationRequest.noPagination(), {issue: issue});
    }

    public cloneMe() {
      this.clone = _.cloneDeep(this);
    }

    public isUpdated() {
        if(this.clone && (this.status !== this.clone.status)) return true;
        return false;
    }

    public isPropertyUpdated(property: string) {
        // console.log(property, this[property], this.clone[property])
        if(this.clone && (this[property] !== this.clone[property])) return true;
        return false;
    }

    public getAttributeNames(): Array<string> {
        return Object.getOwnPropertyNames(this);
    }

    public isAllowedToUpdate(): Boolean {
        let allAttributes = this.getAttributeNames();
        //filter out undefined properties
        let updatedProperties = allAttributes.filter(a => {
            if(this.isPropertyUpdated(a)) {
                return a;
            }
        });
        for(const p of updatedProperties) {
            if(!this.permittedAttributes.includes(p)) {
                return false;
            }
        }
        return true;
    }

    public generateUpdatedPropertiesObject(): any {
        const updated = this.permittedAttributes.filter(attr => this.isPropertyUpdated(attr));
        let output = {};
        if(updated && updated.length) {
            for( const prop of updated) {
                output[prop] = this[prop];
            }   
        }
        output['forgeId'] = this.forgeId;

        //check if dueDateString changed
        if(this.isPropertyUpdated('dueDateString'))
        {
            output['dueDateString'] = this.dueDateString;
        }

        //assignedToType required when assignedTo changed
        if(this.isPropertyUpdated('assignedTo')) {
            output['assignedToType'] = this.assignedToType;
        }

        const customAttrChanges = this.getChangedCustomAttrs();
        if(customAttrChanges)
        {
            output['customAttributes'] = customAttrChanges;
        }
        return output;
    }

    private getChangedCustomAttrs(): any[] | null
    {
        if(this.clone && (this.customAttributes == this.clone.customAttributes))return null;
        console.log("this issue: ", this);
        const changes = this.customAttributes.map(custom => {
            let objFound = false;
            for(const c of this.clone.customAttributes)
            {
                if(c.attributeDefinitionId == custom.attributeDefinitionId 
                    && c.value == custom.value
                ) { 
                    objFound = true;
                };
            }
            if(!objFound) return custom;
        }).filter(d => d);
        return changes;
    }
}
